import AttachFiles from './AttachFiles';

export default AttachFiles;